<template>
  <div class="waiting-next-slide-wrapper">
    <div class="slide-title" v-if="slide.type !== 'scale'">
      <h2
        v-if="slide.title"
        class="mt-0 text-left slide-title-style"
        v-html="dataValue"
      />
      <p class="text-left slide-title-style title-desc" v-if="slide.titleDesc">
        {{ slide.titleDesc }}
      </p>
      <div
        v-if="slide.image"
        class="slide-img-wrapper"
        :class="{'question-type': slide.type === 'openEnded' || slide.type === 'wordCloud'}"
      >
        <img :src="slide.image.large" alt class="slide-img">
      </div>
    </div>
    <div class="waiting-next-slide">
      <div class="img-puping">
        <div class="icon-wrapper">
          <i class="custom-text-white fas fa-check" />
        </div>
      </div>
      <div class="title">
        {{ waitingTitle }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  mixins: [ClickableTitleMixin],
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isLastSlide() {
      return this.presentation
        && this.slide
        && this.presentation.lastSlide === this.slide.id
    },
    waitingTitle() {
      if (this.presentation && this.presentation.audiencePacing) {
        return this.$t('audiencePacingWaitingScreen')
      }

      return this.isLastSlide
        ? this.$t('audiencePacingWaitingScreen')
        : `${this.$t('audiencePacingWaitingScreen')} ${this.$t('waitingScreen')}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.slide-title-style {
  padding: 0 16px;
}

.waiting-next-slide {
  padding: 16px;
  padding-bottom: 0;
  text-align: center;

  .title {
    margin-top: 24px;
    margin-bottom: 8px;
    padding-bottom: 16px;
    font-size: 18px;
    line-height: 1.5em;
  }

  .desp {
    color: #555;
    margin-bottom: 12px;
  }

  .img-puping {
    .icon-wrapper {
      width: 6em;
      height: 6em;
      margin: 0 auto;
      border-radius: 50%;
      background-color: $primary-color;
      border: 2px solid #ffffff;
      position: relative;
      .fas {
        font-size: 3.85em;
        position: absolute;
        top: 17px;
        left: 16px;
      }
    }
  }
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;

  &.question-type {
    height: 300px;
    padding: 0 0 0.83em 0;
    .slide-img {
      height: 100%;
      margin: 0 auto;
      max-height: unset;
    }
  }

  .slide-img {
    margin-bottom: 16px;
  }
}
</style>
